import React, { useState } from "react";
import { Button, CircularProgress, Snackbar } from "@mui/material";
import IosShareRoundedIcon from "@mui/icons-material/IosShareRounded";
import { SITE, drawMatchdayCard, drawScorersCard, drawStandingsCard, drawTeamCard, shareCanvas } from "../../utils/shareCard";
import { withPredictedScores } from "../../utils/sharePredictions";

const DRAW = { team: drawTeamCard, matchday: drawMatchdayCard, scorers: drawScorersCard, standings: drawStandingsCard };

const slug = (s) => String(s || "hsl").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

/** Builds a 1080×1350 image card in the browser and opens the share sheet (or downloads it). */
export default function ShareButton({ kind, data, label = "Share", variant = "light", iconOnly = false, sx }) {
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");

  const onClick = async () => {
    setBusy(true);
    try {
      const path = data.path ?? window.location.pathname;
      const query = data.path ? data.search ?? "" : window.location.search;
      let games = data.games;
      if (kind === "matchday" && games) games = await withPredictedScores(games).catch(() => games);
      const canvas = await DRAW[kind]({ ...data, games, path });
      const name = kind === "team" ? data.team?.name : `${data.subtitle || ""} ${data.title || ""}`;
      const outcome = await shareCanvas(canvas, `${slug(name)}.png`, `https://${SITE}${path}${query}`);
      if (outcome === "downloaded") setNotice("Image saved to your downloads");
      if (outcome === "failed") setNotice("Couldn't create the image");
    } catch (e) {
      console.error("Share card:", e);
      setNotice("Couldn't create the image");
    } finally {
      setBusy(false);
    }
  };

  const light = variant === "light";
  return (
    <>
      <Button
        onClick={onClick}
        aria-label={label}
        title={label}
        disabled={busy}
        size="small"
        startIcon={iconOnly ? undefined : busy ? <CircularProgress size={14} color="inherit" /> : <IosShareRoundedIcon sx={{ fontSize: 18 }} />}
        sx={{
          textTransform: "none",
          fontWeight: 800,
          borderRadius: 999,
          px: 1.75,
          color: light ? "#fff" : "#111",
          bgcolor: light ? "rgba(255,255,255,0.14)" : "#f4f4f5",
          border: light ? "1px solid rgba(255,255,255,0.28)" : "1px solid #e4e4e7",
          "&:hover": { bgcolor: light ? "rgba(255,255,255,0.24)" : "#e4e4e7" },
          "&.Mui-disabled": { color: light ? "rgba(255,255,255,0.7)" : "#888" },
          ...(iconOnly && { minWidth: 0, width: 32, height: 32, px: 0 }),
          ...sx,
        }}
      >
        {iconOnly ? busy ? <CircularProgress size={14} color="inherit" /> : <IosShareRoundedIcon sx={{ fontSize: 17 }} /> : label}
      </Button>
      <Snackbar open={!!notice} autoHideDuration={2500} onClose={() => setNotice("")} message={notice} />
    </>
  );
}
